import { Fragment, useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import LoadingSpinner from '../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { twinFetchPostText } from '../../../../utils/globals/data'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { RegisterCheckWithText, RegisterErrorWithText } from '../../../login/screens/Register'

interface ActivateFingerprintInnerProps extends ActivateFingerprintInnerLogicProps { }

const ActivateFingerprintInner: React.FC<ActivateFingerprintInnerProps> = () => {
    const { activatedSucc } = useActivateFingerprintInnerLogic()
    const Component = decideComponent(activatedSucc)
    return (
        <Fragment>
            <Component />
        </Fragment>
    )
}

interface ActivateFingerprintInnerLogicProps { }

const useActivateFingerprintInnerLogic = () => {
    const [activatedSucc, setActivatedSucc] = useState<boolean | null>(null)
    const { fingerprint_token } = useParams()

    const activateToken = useCallback(async () => {
        const result = await twinFetchPostText('/api/activateDevice', {
            fingerprint_token
        })
        if (result && result === 'true') {
            setActivatedSucc(true)
        } else {
            setActivatedSucc(false)
        }
    }, [fingerprint_token])

    useEffect(() => {
        activateToken()
    }, [activateToken])

    return { activatedSucc }
}

const decideComponent = (activatedSucc: boolean | null) => {
    if (activatedSucc) {
        return SuccessActivated
    } else if (activatedSucc === false) {
        return ErrorActivating
    }
    return LoadingActivating
}

const SuccessActivated: React.FC = () => {
    const { t } = useTwinTranslation()
    return (
        <div className='flex flex-col items-center justify-between my-auto'>
            <RegisterCheckWithText title={t('locationActivated', 'Localización activada')} subtitle={t('locationActivatedExtended', 'Localización activada correctamente. Puedes volver a la pantalla de inicio de sesión para empezar a trabajar.')} />
        </div>
    )
}

const ErrorActivating: React.FC = () => {
    const { t } = useTwinTranslation()
    return (
        <div className='flex flex-col items-center justify-between my-auto'>
            <RegisterErrorWithText title={t('locationNotActivated', 'Localización no activada')} subtitle={t('locationNoActivatedExtended', 'Localización no activada correctamente. El enlace es inválido o ha caducado. Si no sabes como solucionarlo, contacta a soporte.')} />
        </div>
    )
}

const LoadingActivating: React.FC = () => {
    return (
        <div className='flex flex-col items-center justify-between'>
            <LoadingSpinner />
        </div>
    )
}


export default ActivateFingerprintInner